<ng-template #signUpModal let-modal>
  <div class="modal-header" [ngClass]="{'signup-intro-header': currentScreen !== 'register'}">
    <h4 *ngIf="currentScreen === 'register'" class="modal-title" id="modal-basic-title">Sign Up</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      title="Close Modal"
      (click)="modal.dismiss('Cross click'); resetForm()"
    ></button>
  </div>

  <div class="modal-body" [ngClass]="{'signup-intro-body': currentScreen !== 'register'}">
    <div *ngIf="currentScreen === 'role'" class="signup-screen signup-role-screen">
      <p class="eyebrow">Welcome to HUNGERY</p>
      <p class="signup-screen-title">You are a...</p>
      <button type="button" class="role-btn" (click)="showRegistrationForm()">
        <div class="role-icon ri-foodie">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5C4FC2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
            <line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>
          </svg>
        </div>
        <div>
          <p class="role-name">Foodie</p>
          <p class="role-desc">Discover restaurants, earn rewards &amp; grab deals</p>
        </div>
      </button>
      <button type="button" class="role-btn" (click)="showOwnerGuide()">
        <div class="role-icon ri-owner">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D9E75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <div>
          <p class="role-name">Restaurant Owner</p>
          <p class="role-desc">List your restaurant and manage promotions</p>
        </div>
      </button>
      <button type="button" class="role-btn" (click)="showStaffGuide()">
        <div class="role-icon ri-staff">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4830A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div>
          <p class="role-name">Staff Member</p>
          <p class="role-desc">Access your workplace account on Hungery</p>
        </div>
      </button>
    </div>

    <div *ngIf="currentScreen === 'owner'" class="signup-screen signup-guide-screen">
      <button type="button" class="back-link" (click)="showRoleSelection()">&#8592; Back</button>
      <p class="eyebrow">Restaurant Owner</p>
      <p class="signup-screen-title">Getting started</p>
      <ul class="steps-list">
        <li><span class="step-num">1</span><span class="step-txt">Register your free HUNGERY user account</span></li>
        <li><span class="step-num">2</span><span class="step-txt">Then register your free Business account</span></li>
        <li><span class="step-num">3</span><span class="step-txt">Add as much information, menu and pictures as you can to attract your customers</span></li>
        <li><span class="step-num">4</span><span class="step-txt">Enjoy!</span></li>
      </ul>
      <div class="info-note">After signing up, look for the <strong>Register Business</strong> button in the top banner next to your profile.</div>
      <button type="button" class="btn btn-primary w-100 btn-lg" (click)="showRegistrationForm()">Create My Account</button>
      <button type="button" class="btn btn-secondary w-100" (click)="showRoleSelection()">Back</button>
    </div>

    <div *ngIf="currentScreen === 'staff'" class="signup-screen signup-guide-screen">
      <button type="button" class="back-link" (click)="showRoleSelection()">&#8592; Back</button>
      <p class="eyebrow">Staff Member</p>
      <p class="signup-screen-title">Getting started</p>
      <ul class="steps-list">
        <li><span class="step-num">1</span><span class="step-txt">Register your free HUNGERY user account</span></li>
        <li><span class="step-num">2</span><span class="step-txt">Then contact your business owner to add your account to their business as staff</span></li>
        <li><span class="step-num">3</span><span class="step-txt">Login to the Business section with your HUNGERY personal account</span></li>
      </ul>
      <div class="info-note">No separate staff registration needed - your owner links you directly from their Business Dashboard.</div>
      <button type="button" class="btn btn-primary w-100 btn-lg" (click)="showRegistrationForm()">Create My Account</button>
      <button type="button" class="btn btn-secondary w-100" (click)="showRoleSelection()">Back</button>
    </div>

    <form *ngIf="currentScreen === 'register'" [formGroup]="formGroup">
      <h5 class="modal-info-text">CREATE YOUR ACCOUNT</h5>
      <div class="row modal-form-row">
        <div class="col-12">
          <div>
            <app-input [inputType]="'text'"
                       [fieldValue]="item.firstName"
                       [fieldText]="'firstName'"
                       [fControl]="formGroup.controls['FirstName']"
                       [inputClass]="'form-control'"
                       [inputPlaceholder]="'Enter First Name'"
                       [inputLabel]="'First Name'"
                       [labelClass]="'form-label'"
                       (onTextChange)="onTextValueChange($event)"
                       appAlphabetOnly
                       [maxLengthValidationMsg]="
                'First Name must be at most 25 characters long.'
              "
                       [customErrorValidationMsg]="' First Name must contain only alphabets'"
                       tabindex="1"
                       (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
        <div class="col-12">
          <div>
            <app-input [inputType]="'text'"
                       [fieldValue]="item.lastName"
                       [fieldText]="'lastName'"
                       [fControl]="formGroup.controls['LastName']"
                       [inputClass]="'form-control'"
                       [inputPlaceholder]="'Enter Last Name'"
                       [inputLabel]="'Last Name'"
                       [labelClass]="'form-label'"
                       (onTextChange)="onTextValueChange($event)"
                       [maxLengthValidationMsg]="
                'Last Name must be at most 25 characters long.'
              "
                       [customErrorValidationMsg]="
                'Last Name must contain only alphabets'
              "
                       appAlphabetOnly
                       tabindex="2"
                       (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
        <div class="col-12">
          <div>
            <app-input [inputType]="'email'"
                       [fieldValue]="item.email"
                       [fieldText]="'email'"
                       [fControl]="formGroup.controls['Email']"
                       [inputClass]="'form-control'"
                       [inputPlaceholder]="'Enter Email'"
                       [inputLabel]="'Email'"
                       [labelClass]="'form-label'"
                       (onTextChange)="onTextValueChange($event)"
                       [customErrorValidationMsg]="'Email already exist'"
                       [patternValidationMsg]="'Email is invalid'"
                       [maxLengthValidationMsg]="
              'Email must be at most 50 characters long.'
            "
                       tabindex="3"
                       (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
        <div class="col-12">
          <app-input-password [fieldValue]="item.password"
                              [fieldText]="'password'"
                              [fControl]="formGroup.controls['Password']"
                              [inputClass]="'form-control'"
                              [inputLabel]="'Password'"
                              [inputPlaceholder]="'Enter Password'"
                              [labelClass]="'form-label'"
                              (onTextChange)="onTextValueChange($event)"
                              [minLengthValidationMsg]="'Password must be at least 6 characters long.'"
                              [maxLengthValidationMsg]="'Password must be at most 25 characters long.'"
                              [patternValidationMsg]="
              'Password can contain letters, numbers or combination of letters and numbers.'
            "
                              tabindex="4"
                              (keydown.enter)="$event.preventDefault()"></app-input-password>
        </div>
        <div class="col-12">
          <app-input-password [fieldValue]="item.confirmPassword"
                              [fieldText]="'confirmPassword'"
                              [fControl]="formGroup.controls['RepeatPassword']"
                              [inputClass]="'form-control'"
                              [inputPlaceholder]="'Enter Repeat Password'"
                              [inputLabel]="'Repeat Password'"
                              [labelClass]="'form-label'"
                              (onTextChange)="onTextValueChange($event)"
                              [minLengthValidationMsg]="'Confirm Password must be at least 6 characters long.'"
                              [maxLengthValidationMsg]="'Confirm Password must be at most 25 characters long.'"
                              [patternValidationMsg]="
              'Password can contain letters, numbers or combination of letters and numbers.'
            "
                              [customErrorValidationMsg]="
              'The password and confirmation password do not match.'
            "
                              tabindex="5"
                              (keydown.enter)="$event.preventDefault()"
                              (keyup.enter)="CheckEmail()"
                              (keydown.tab)="$event.preventDefault()"
                              (keyup.tab)="CheckEmail()"></app-input-password>
        </div>
        <div class="col-12 mt-4">
          <app-button [btnText]="'Sign Up'"
                      [btnTitle]="'Sign Up'"
                      [isDisable]="isDisableSignUpBtn"
                      [btnCss]="'btn btn-primary w-100 btn-lg'"
                      (onBtnClick)="CheckEmail()"></app-button>
        </div>
        <div class="social-login text-center">
          <p>or continue with</p>
          <div class="social-icons">
            <a href="#" class="social-icon google" (click)="$event.preventDefault(); loginWithGoogle()" aria-label="Google Login">
              <img src="./assets/images/google.svg" alt="Google" />
            </a>
            <a href="#" class="social-icon facebook" (click)="$event.preventDefault(); loginWithFacebook()" aria-label="Facebook Login">
              <img src="./assets/images/facebook.svg" alt="Facebook" />
            </a>
            <a href="#" class="social-icon instagram" (click)="$event.preventDefault(); loginWithInstagram()" aria-label="Instagram Login">
              <img src="./assets/images/instagram.svg" alt="Instagram" />
            </a>
            <a href="#" class="social-icon apple" (click)="$event.preventDefault(); loginWithApple()" aria-label="Apple Login">
              <img src="./assets/images/apple.svg" alt="Apple" />
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<app-asking-details #askingDetailsModal></app-asking-details>
